// ================================================================
// 冷啟動等候畫面
// ================================================================
// 功能：Cloud Run scale-to-zero 冷啟動時，第一個請求要等後端開機
//      （約數十秒），顯示動態等候線條，避免使用者以為系統當機
// ================================================================

import React, { useEffect, useState } from 'react';
import { Backdrop, Box, Typography, LinearProgress } from '@mui/material';
import { subscribeColdStart } from '../api/client';

const ColdStartOverlay: React.FC = () => {
  const [waking, setWaking] = useState(false);

  useEffect(() => {
    return subscribeColdStart(setWaking);
  }, []);

  return (
    <Backdrop
      open={waking}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 1,
        color: '#fff',
        flexDirection: 'column',
        backgroundColor: 'rgba(20, 10, 40, 0.85)',
      }}
    >
      <Box sx={{ width: '80%', maxWidth: 360, textAlign: 'center' }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          等待大師上線中...
        </Typography>
        <LinearProgress color="secondary" sx={{ borderRadius: 1, height: 6 }} />
        <Typography variant="body2" sx={{ mt: 2, opacity: 0.8 }}>
          正在準備您的專屬命理服務，請稍候片刻
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default ColdStartOverlay;
